import React from 'react';
import './list.scss';

const List = ({ items = null }) => {
  return (
    <div className="list-container">
      {items.map(listItem => (
        <div key={listItem.id} className="list-item">
          <div className="list-item-icon">
            <span className="icon">🍞</span>
          </div>
          <div className="list-item-content">
            <h3 className="list-item-title">{listItem.title}</h3>
            {listItem.description && (
              <p className="list-item-description">{listItem.description}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default List;
